// Selector to get compare items
export const selectCompareItems = (state) => state.compare.items;

// Selector to check if a product is in the compare
export const selectIsProductInCompare = (productId) => (state) =>
  state.compare.items.some((item) => item.id === productId);
